import { compose } from 'recompose';

import PostsList from './PostsList';

const enhance = compose();

export default enhance(PostsList);
